
const digest = 'e578206d95f0f171cd560b72350ae3416da05ce56319dcacb00cbe12a56ee769';
const classes = {"wrapper":"_wrapper_7yvsw_1","item":"_item_7yvsw_6"};
const css = `._wrapper_7yvsw_1 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
._wrapper_7yvsw_1 ._item_7yvsw_6 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  color: #212357;
  align-items: center;
}
._wrapper_7yvsw_1 ._item_7yvsw_6 span {
  font-weight: 600;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  